import { useFilterUtilAgeBracketContext } from "./filter-util-age-bracket.context";

export function FilterUtilAgeBracket() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterUtilAgeBracketContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}